import { useSelector } from 'react-redux'
import {
  activeSheetSelector,
  activeEntrySelector,
} from 'apps/builder/store/selectors'
import { getEntryLabelLimit } from 'apps/builder/components/workspace/fields/helpers'
import { lib } from '@gocanvas/client'
const { applyValidations } = lib

export const STANDARD_PANEL = 'Standard'

export const LabelInput = {
  label: 'Label',
  settingType: 'longTextInput',
  property: 'label',
  updateType: 'entry',
  additionalClasses: 'textarea--constrained',
  additionalProps: () => {
    const activeSheet = useSelector(activeSheetSelector)
    const activeEntry = useSelector(activeEntrySelector)
    return {
      maxLength: getEntryLabelLimit(activeSheet, activeEntry),
    }
  }
}

export const EntryTypeSelect = {
  label: 'Type',
  settingType: 'typeSelect',
  updateType: 'entry',
}

// TODO: We may need different Default Value settings for different field types
// or the ability to pass in a custom validation method
export const DefaultValueInput = {
  label: 'Default Value',
  settingType: 'textInput',
  property: 'default',
  updateType: 'entry',
  validation: data => {
    return applyValidations(
      { ...data, value: data.default },
      { disableRequired: true }
    )
  },
  placeholder: ' ',
}

export const DefaultMultiLineValueInput = {
  label: 'Default Value',
  settingType: 'longTextInput',
  property: 'default',
  updateType: 'entry',
  validation: data => {
    return applyValidations(
      { ...data, value: data.default },
      { disableRequired: true }
    )
  },
  placeholder: ' ',
}

export const RequiredToggle = {
  label: 'Required',
  settingType: 'toggleInput',
  property: 'required',
  updateType: 'entry',
}

export const ReadOnlyToggle = {
  label: 'Read Only',
  settingType: 'toggleInput',
  property: 'read_only',
  updateType: 'entry',
}

export const StandardSettingsPanel = (settings = []) => ({
  label: STANDARD_PANEL,
  defaultOpen: true,
  settings,
})
